module.exports = __webpack_public_path__ + "static/media/rajat.1b538a35.jpeg";